import { defineComponent as _defineComponent } from 'vue'
import { ref, Ref } from "vue";
import { useApiStore, type Project } from "@/stores/api";


export default /*#__PURE__*/_defineComponent({
  props: {
    projectIds: { type: Array, required: false, default: () => [] }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as { projectIds: number[] }



const apiStore = useApiStore();

const projects: Ref<Project[]> = ref([]);

let params: { categories?: number[]; per_page?: number; include?: number[] } = { categories: [3], per_page: 2 };
if (props.projectIds.length) {
    params = { include: props.projectIds };
}

apiStore.getProjects(params).then((p: Project[]) => {
    if (props.projectIds.length) {
        p.forEach(function (a) {
            projects.value[props.projectIds.indexOf(a.id)] = a;
        });
    } else {
        projects.value = p;
    }
});

const __returned__ = { props, apiStore, projects, params }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})